import { Box } from '@mantine/core';
import { forwardRef, useState } from 'react';
import { useReducedMotion } from '../hooks';

export interface HoverScaleProps {
  children: React.ReactNode;
  scale?: number;
  duration?: number;
  timingFunction?: string;
}

const HoverScale = forwardRef<HTMLDivElement, HoverScaleProps>(
  (
    {
      children,
      scale = 1.05,
      duration = 200,
      timingFunction = 'ease-out',
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();
    const [isHovered, setIsHovered] = useState(false);

    return (
      <Box
        ref={ref}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          transform: isHovered && !reducedMotion ? `scale(${scale})` : 'scale(1)',
          transition: reducedMotion ? 'none' : `transform ${duration}ms ${timingFunction}`,
          display: 'inline-block',
        }}
      >
        {children}
      </Box>
    );
  }
);

HoverScale.displayName = 'HoverScale';

export default HoverScale;
